export type Progress = 0 | 1 | 2 | 3

export const getScoreValue = (score: number): string => (Math.floor(score) / 10).toFixed(1)

export const getScoreRange = (score: number | undefined): Progress => {
  if (!score) return 0
  const flooredScore = Math.floor(score)
  if (flooredScore >= 80) return 3
  if (flooredScore >= 60) return 2
  return 1
}
